import styled from 'styled-components'


export const CardContainer = styled.div`

`;

export const CardContent = styled.div`
    display:flex;
    flex-flow: column;
    align-items:center;
    justify-content:center;
`;

export const DataGrid = styled.div`
    width:70%;
    margin-top:5px;
    display:grid;
    grid-template-columns: 1fr 1fr;

    .data-title, .data-bico{
        margin-bottom:3px;
        padding: 0px 4px;
        font-weight:500;
    }

    .data-title{
        text-align:left;
    }
    .data-bico{
        text-align:right;
        background-color:white;
    }

    .azul{
        color:#fff;
        background-color:#3ea4db;
    }
    .vermelho{
        color:#fff;
        background-color:#d8705b;
    }
    .verde{
        color:#fff;
        background-color:#98cb55;
    }
    .amarelo{
        color:#000      ;
        background-color:#f2f362;
    }

    @media(max-width:320px){
        width:80%;
    }
`;